import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PostalAddressSchema = withDefaults({
  type: 'postal-address',
  objectExtensions: ['postal-address'],
  fields: [
    {
      kind: 'attribute',
      name: 'addressLine1',
    },
    {
      kind: 'attribute',
      name: 'addressLine2',
    },
    {
      kind: 'attribute',
      name: 'addressLine3',
    },
    {
      kind: 'attribute',
      name: 'city',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'postalCode',
    },
    {
      kind: 'attribute',
      name: 'country',
    },
    {
      kind: 'attribute',
      name: 'contactType',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'isVerified',
    },
    {
      kind: 'attribute',
      name: 'postalAddressType',
    },
    {
      kind: 'attribute',
      name: 'paymentMethodType',
    },
    {
      kind: 'attribute',
      name: 'servicerAddressIdentifier',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'financialInstitution',
      type: 'financial-institution',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'postalAddressable',
      type: 'postal-addressable',
      options: {
        async: false,
        polymorphic: true,
        inverse: 'ownedPostalAddresses',
      },
    },
  ],
});

export default PostalAddressSchema;
